import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../utils/cn';

export interface TermsCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  onViewTerms: () => void;
  error?: string;
  className?: string;
}

export const TermsCheckbox: React.FC<TermsCheckboxProps> = ({
  checked,
  onChange,
  onViewTerms,
  error,
  className
}) => {
  const navigate = useNavigate();

  const handlePrivacyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/policies/privacy');
  };

  return (
    <div className={cn('space-y-1', className)}>
      <div className="flex items-center gap-1">
        <input
          type="checkbox"
          id="terms-checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary focus:ring-2 cursor-pointer flex-shrink-0"
        />
        <label
          htmlFor="terms-checkbox"
          className="text-sm text-muted-foreground cursor-pointer select-none"
        >
          <span className="text-red-500 mr-1">*</span>
          I agree to the{' '}
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              onViewTerms();
            }}
            className="text-primary hover:underline font-medium"
          >
            terms and conditions
          </button>
          {' '}and{' '}
          <button
            type="button"
            onClick={handlePrivacyClick}
            className="text-primary hover:underline font-medium"
          >
            privacy policy
          </button>
        </label>
      </div>
      {error && (
        <p className="text-xs text-red-600 dark:text-red-400 px-1">
          {error}
        </p>
      )}
    </div>
  );
};

export default TermsCheckbox;
